export var ViewVisibilityType;
(function (ViewVisibilityType) {
    ViewVisibilityType["Individual"] = "INDIVIDUAL";
    ViewVisibilityType["Public"] = "PUBLIC";
})(ViewVisibilityType || (ViewVisibilityType = {}));
//# sourceMappingURL=visibility.js.map